import React, { useState } from 'react';
import { Badge, Button, Card, Col, Row } from 'react-bootstrap';
import renderUtils from '../../../helpers/renderUtils';
import HouseOfferAmount from './HouseOfferAmount';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import Tooltip from '../../../components/tooltip/Tooltip';
import { useLocation, useNavigate } from 'react-router-dom';
import HouseFeatures from '../../../components/lakeview/HouseFeatures';
import HouseMainImage from '../../../components/lakeview/house/HouseMainImage';
import Price from '../../../components/lakeview/Price';
import LightButton from '../../../components/button/LightButton';
import GuestsSummary from '../../../components/lakeview/GuestsSummary';
import ShortGuestsSummary from '../../../components/lakeview/ShortGuestsSummary';

const HouseOfferCard = ({ offer }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openPaymentSummary, setOpenPaymentSummary] = useState(false);
  const [openFullDescription, setOpenFullDescription] = useState(false);

  const {
    house,
    paymentSummary,
    nights,
    guests,
    startDate,
    endDate,
    available
  } = offer;

  const totalGuests = guests.adults + guests.children + guests.infants;


  return (
    <Card className="mb-4 p-2">
      <Row className="g-0">
        <Col md={4}>
          <HouseMainImage house={house} />
        </Col>
        <Col md={8} className="d-flex flex-column">
          <Card.Body className="d-flex flex-column h-100 ps-4 position-relative">
            <Card.Title className="d-flex justify-content-between align-items-center cursor-pointer">
              <div onClick={() => navigate('/house/' + house.id + '/details')}>
                <strong>{house.name}</strong>
              </div>
              {paymentSummary && (
                <Tooltip tooltip={'Szczegóły wyceny'}>
                  <div
                    onClick={() => setOpenPaymentSummary(true)}
                    className="text-end text-primary fw-bold fs-5 cursor-pointer bg-hover-light rounded-2 p-2"
                  >
                    <Price value={paymentSummary.total} />
                    <small className="text-muted">
                      / {nights} {renderUtils.getNightLabel(nights)}
                    </small>
                  </div>
                </Tooltip>
              )}
            </Card.Title>

            <HouseFeatures house={house} />

            <Card.Text
              onClick={() => setOpenFullDescription(true)}
              className="mb-2 text-muted description-clamp cursor-pointer">
              {house.description}
            </Card.Text>


            <div className="small text-muted mt-auto">

              {renderUtils.formatDate(startDate)} - {renderUtils.formatDate(endDate)}
              <>
                <span className="mx-2">·</span>
                <span>
                    {nights}{' '}{renderUtils.getNightLabel(nights)}
                  </span>
              </>
              <br />
              <ShortGuestsSummary className={"mt-2"} guests={guests} label={true} />
            </div>

            {available ? (
              <Button
                className="position-absolute bottom-0 end-0 m-3"
                onClick={() =>
                  navigate({
                    pathname: '/house-offer/' + house.id,
                    search: location.search
                  })
                }
                variant="primary"
              >
                Wybierz
              </Button>
            ) : (
              <Tooltip
                divClassName={'position-absolute bottom-0 end-0'}
                tooltip={
                  <div>
                    {offer.unavailableReasons.map((reason, index) => (
                      <div key={index}>{reason}</div>
                    ))}
                  </div>
                }
              >
                <LightButton className=" m-3 cursor-pointer">
                  Niedostępny
                </LightButton>
              </Tooltip>
            )}

            <ConfirmModal
              size={'lg'}
              title={'Szczegóły wyceny'}
              show={openPaymentSummary}
              setShow={setOpenPaymentSummary}
              buttonsConf={{ save: 'Kontynuj' }}
            >
              <HouseOfferAmount paymentSummary={paymentSummary} />
            </ConfirmModal>
          </Card.Body>
          <ConfirmModal
            key={house.id}
            show={openFullDescription}
            setShow={setOpenFullDescription}
            size="lg"
            title="Opis domku"
            buttonsConf={{ save: 'Zamknij' }}
          >
            {openFullDescription && (
              <div className="white-space">
                {house.description}
              </div>
            )}
          </ConfirmModal>
        </Col>
      </Row>
    </Card>
  );
};

export default HouseOfferCard;
